/** Estados de México, orden alfabético (nombres oficiales). */
export const MEXICO_STATES = [
	"Aguascalientes",
	"Baja California",
	"Baja California Sur",
	"Campeche",
	"Chiapas",
	"Chihuahua",
	"Ciudad de México",
	"Coahuila",
	"Colima",
	"Durango",
	"Estado de México",
	"Guanajuato",
	"Guerrero",
	"Hidalgo",
	"Jalisco",
	"Michoacán",
	"Morelos",
	"Nayarit",
	"Nuevo León",
	"Oaxaca",
	"Puebla",
	"Querétaro",
	"Quintana Roo",
	"San Luis Potosí",
	"Sinaloa",
	"Sonora",
	"Tabasco",
	"Tamaulipas",
	"Tlaxcala",
	"Veracruz",
	"Yucatán",
	"Zacatecas"
] as const

export type MexicoState = (typeof MEXICO_STATES)[number]
